<div class="modal-header"><h2 class="modal-title">Part Type Select</h2></div>
<div class="modal-body">
    <dx-form [formData]="entity">
        <dxi-item dataField="partTypeId"
                  [label]="{ text: 'Part Type' }"
                  editorType="dxSelectBox"
                  [editorOptions]="{ items: partTypes, valueExpr: 'id', displayExpr: 'name', searchEnabled: true }"></dxi-item>
    </dx-form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="save()">Save</button>
    <button type="button" class="btn btn-default" (click)="cancel()">Cancel</button>
</div>
